export default __webpack_public_path__ + "4f3339b75dc7ce1043d3e516f0a4051b.svg";